module.exports = __webpack_public_path__ + "static/img/0203_T01_01.49a1fe9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sub/02/0203_T01_01.png
// module id = 4RJi
// module chunks = 1